// src/stores/sessionStore.js
import { defineStore } from 'pinia';
import { IUser, ITenant } from '@airin/shared-types';

export const useSessionStore = defineStore('session', {
  state: () => ({
    token: null,
    user: null as IUser | null,
    tenant: null as ITenant | null,
  }),
  actions: {
    setToken(token: any) {
      this.token = token;
    },
    setUser(user: IUser | null) {
      this.user = user;
    },
    setTenant(tenant: any) {
      this.tenant = tenant;
    }
  },
  getters: {
    getUserById(): any {
      return this.user;
    },
    getTenant: (state) => () => {
      return state.tenant;
    },
    getUser: (state) => () => {
      return state.user;
    },
  }
});
